/**
 * 押した結果をその場で伝える短い通知（画面下、3秒）。
 * ボタンと同じ動詞で「承認しました」「提出しました（申請番号 2026-0012）」。
 * 大事な情報をトーストだけで伝えない（エラーは必ず画面の該当箇所にも出す）。
 */
import { useSyncExternalStore } from "react";

interface ToastItem { id: number; text: string; tone: "ok" | "error" }

let items: ToastItem[] = [];
let seq = 0;
const listeners = new Set<() => void>();
function emit(): void { for (const l of listeners) l(); }

export const toast = {
  show(text: string, tone: ToastItem["tone"] = "ok", ms = 3000): void {
    const id = ++seq;
    items = [...items.slice(-2), { id, text, tone }];
    emit();
    setTimeout(() => toast.dismiss(id), tone === "error" ? Math.max(ms, 6000) : ms);
  },
  dismiss(id: number): void {
    items = items.filter((x) => x.id !== id);
    emit();
  },
};

function subscribe(fn: () => void): () => void {
  listeners.add(fn);
  return () => { listeners.delete(fn); };
}

export function ToastRegion({ closeLabel }: { closeLabel: string }) {
  const list = useSyncExternalStore(subscribe, () => items);
  return (
    <div className="toast-region" role="status" aria-live="polite" aria-atomic="false">
      {list.map((x) => (
        <div key={x.id} className={`toast${x.tone === "error" ? " error" : ""}`}>
          <span>{x.text}</span>
          <button type="button" onClick={() => toast.dismiss(x.id)} aria-label={closeLabel}>×</button>
        </div>
      ))}
    </div>
  );
}
